import { useAuthStore, type AuthUser } from '@/shared/stores/auth.store'

type ImpersonationFields = Pick<AuthUser, 'is_impersonating' | 'real_actor' | 'impersonation_expires_at'>

/**
 * THE impersonation check for every walkthrough surface: welcome card, page
 * cards, the ? beacon, tour-status writes and every per-browser write. Any of
 * the /auth/me impersonation fields counts (fail closed). Defaults to the
 * current store user.
 */
export function isImpersonating(u: ImpersonationFields | null | undefined = useAuthStore.getState().user): boolean {
  return !!(u && (u.is_impersonating || u.real_actor || u.impersonation_expires_at))
}
